import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { searchContent } from '@plone/volto/actions/search/search';
import './StatsCounter.css';

const StatsCounterView = ({ data }) => {
  const dispatch = useDispatch();

  const type1 = data?.stat1_portal_type || 'people';
  const type2 = data?.stat2_portal_type || 'project';
  const type3 = data?.stat3_portal_type || 'publication';

  const key1 = `stats-counter:${type1}`;
  const key2 = `stats-counter:${type2}`;
  const key3 = `stats-counter:${type3}`;

  useEffect(() => {
    dispatch(searchContent('', { portal_type: type1, b_size: 0 }, key1));
  }, [dispatch, type1, key1]);

  useEffect(() => {
    dispatch(searchContent('', { portal_type: type2, b_size: 0 }, key2));
  }, [dispatch, type2, key2]);

  useEffect(() => {
    dispatch(searchContent('', { portal_type: type3, b_size: 0 }, key3));
  }, [dispatch, type3, key3]);

  const count1 = useSelector(
    (state) => state.search.subrequests?.[key1]?.total ?? null,
  );
  const count2 = useSelector(
    (state) => state.search.subrequests?.[key2]?.total ?? null,
  );
  const count3 = useSelector(
    (state) => state.search.subrequests?.[key3]?.total ?? null,
  );

  const stats = [
    {
      label: data?.stat1_label || 'People',
      count: count1,
      description: data?.stat1_description || 'researchers & staff',
    },
    {
      label: data?.stat2_label || 'Projects',
      count: count2,
      description: data?.stat2_description || 'active research projects',
    },
    {
      label: data?.stat3_label || 'Publications',
      count: count3,
      description: data?.stat3_description || 'peer-reviewed publications',
    },
  ];

  return (
    <div className="stats-counter">
      {stats.map(({ label, count, description }) => (
        <div key={label} className="stats-counter__item">
          <div className="stats-counter__label">{label}</div>
          <div className="stats-counter__number">
            {count !== null ? count.toLocaleString('de-DE') : '—'}
          </div>
          <div className="stats-counter__description">{description}</div>
        </div>
      ))}
    </div>
  );
};

StatsCounterView.propTypes = {
  data: PropTypes.object.isRequired,
};

export default StatsCounterView;
